<template>
  <div v-if="visible" class="modal-overlay" @click.self="closeModal">
    <div class="modal">
      <div class="modal-header">
        <h2 class="modal-title">{{ addon ? 'Edytuj dodatek' : 'Dodaj dodatek' }}</h2>
        <button class="close-button" @click="closeModal" aria-label="Zamknij modal">
          <font-awesome-icon icon="xmark" />
        </button>
      </div>

      <form @submit.prevent="handleSubmit" class="modal-form">
        <label for="addon_id">Dodatek *</label>
        <select id="addon_id" v-model.number="form.addon_id" required>
          <option disabled value="">Wybierz dodatek</option>
          <option v-for="a in addons" :key="a.id" :value="a.id">
            {{ a.desc || a.code || 'brak nazwy' }}
          </option>
        </select>

        <label for="trailer_id">Model lawety *</label>
        <select id="trailer_id" v-model.number="form.trailer_id" required>
          <option disabled value="">Wybierz model</option>
          <option v-for="t in trailers" :key="t.id" :value="t.id">
            {{ t.name || 'brak nazwy' }}
          </option>
        </select>

        <label for="price">Cena</label>
        <input id="price" type="number" step="0.01" min="0" v-model.number="form.price" placeholder="Cena w zł" />

        <label class="checkbox-label">
          <input type="checkbox" v-model="form.is_default" />
          Domyślny
        </label>

        <div class="modal-actions">
          <button type="submit" class="save-button">Zapisz</button>
          <button type="button" class="cancel-button" @click="closeModal">Anuluj</button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    visible: Boolean,
    addon: Object,
    addons: Array,
    trailers: Array
  },
  data() {
    return {
      form: {
        addon_id: null,
        trailer_id: null,
        price: '',
        is_default: false,
      }
    }
  },
  watch: {
    addon: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.addon_id = val.addon_id || null
          this.form.trailer_id = val.trailer_id || null
          this.form.price = parseFloat(val.price) || 0
          this.form.is_default = val.is_default === 1
        } else {
          this.form.addon_id = null
          this.form.trailer_id = null
          this.form.price = ''
          this.form.is_default = false
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('save', this.addon?.id || null, {
        addon_id: this.form.addon_id,
        trailer_id: this.form.trailer_id,
        price: this.form.price,
        is_default: this.form.is_default ? 1 : 0
      })
      this.closeModal()
    },
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.modal {
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  background-color: $color-background;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  padding: 16px 20px;
  background-color: $color-primary;
  color: $color-white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  color: $color-white;
  font-size: 1.3rem;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.modal-form {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

label {
  font-weight: 500;
  font-size: 0.95rem;
  color: $color-text;
}

select,
input[type="number"] {
  font-family: 'Inter', sans-serif;
  padding: 10px;
  border: 2px solid $color-grey;
  border-radius: 8px;
  font-size: 1rem;
  transition: border 0.3s ease;

  &:focus {
    border-color: $color-primary;
    outline: none;
  }
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 0.95rem;
  color: $color-text;

  input[type="checkbox"] {
    transform: scale(1.3);
    accent-color: $color-primary;
    width: auto;
    cursor: pointer;
  }
}

.modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: auto;

  button {
    flex: 1;
    padding: 10px 16px;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .save-button {
    background-color: $color-primary;
    color: $color-white;

    &:hover {
      background-color: $color-primary-dark;
    }
  }

  .cancel-button {
    background-color: $color-grey;
    color: $color-text;

    &:hover {
      background-color: $color-grey-dark;
    }
  }
}

@media (max-width: 600px) {
  .modal {
    max-width: 100%;
  }

  .modal-actions {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}
</style>